import React from "react";
import { Card, CardContent } from "./ui/card";
import { Check, ArrowLeft } from "lucide-react";
import CanopyConnect from "./CanopyConnect";

const CanopyConnectScreen = ({ userData, onComplete, onFullApp, onBack }) => {
  return (
    <div className="space-y-6">
      <button
        onClick={onBack}
        className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
      >
        <ArrowLeft className="w-4 h-4 mr-1" />
        Back to options
      </button>
      {/* Progress Overview */}
      <Card className="bg-blue-50 border-blue-100">
        <CardContent className="pt-6">
          <div className="flex items-start gap-3">
            <Check className="w-5 h-5 text-green-500 mt-1" />
            <div>
              <p className="font-medium text-blue-900">Almost there!</p>
              <p className="text-sm text-blue-700">
                Connect directly with your insurance provider to save time
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Canopy Connect Component */}
      <Card>
        <CardContent className="pt-6">
          <CanopyConnect userData={userData} onComplete={onComplete} onBack={onBack} />
        </CardContent>
      </Card>

      {/* Full App Option */}
      {/* <button
        onClick={onFullApp}
        className="w-full text-center text-gray-600 hover:text-gray-900 text-sm"
      >
        Switch to full Ownli experience
      </button> */}
    </div>
  );
};

export default CanopyConnectScreen;
